// Ficha térmica de exhibición para iPhones usados (papel 80mm, ficha ~40mm).
// No guarda nada: usa los datos actuales del equipo y abre la vista de impresión.
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function printUsedTicket(it) {
  if (!it) return;
  const rows = [["MARCA", "Apple"], ["MODELO", it.model]];
  if (it.color) rows.push(["COLOR", it.color]);
  if (it.capacity) rows.push(["GB", it.capacity]);
  if (it.battery_percent != null && it.battery_percent !== "") rows.push(["BATERÍA", `${it.battery_percent}%`]);
  if (it.charge_cycles != null && it.charge_cycles !== "") rows.push(["CICLOS", String(it.charge_cycles)]);
  if (it.sim_type) rows.push(["SIM", it.sim_type]);

  const rowsHtml = rows.map(([l, v]) => `<div class="r"><span class="l">${esc(l)}</span><span class="v">${esc(v)}</span></div>`).join("");
  const imeiHtml = it.imei ? `<div class="imei"><div class="l">IMEI</div><div class="iv">${esc(it.imei)}</div></div>` : "";
  const ownerHtml = it.owner_code ? `<div class="r"><span class="l">DUEÑO</span><span class="v">${esc(it.owner_code)}</span></div>` : "";

  const html = `<!doctype html><html><head><meta charset="utf-8"><title>Ficha ${esc(it.id || "")}</title>
<style>
  @page { size: 80mm auto; margin: 0; }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  html, body { margin: 0; padding: 0; background: #fff; }
  .ticket {
    width: 40mm; padding: 2mm; margin: 0; color: #000; background: #fff;
    font-family: Arial, Helvetica, sans-serif; border: 1.2px solid #000;
  }
  .r { display: flex; justify-content: space-between; align-items: baseline; gap: 1mm;
       padding: 0.6mm 0; border-bottom: 0.6px solid #000; }
  .l { font-weight: 700; font-size: 8pt; letter-spacing: 0.2px; }
  .v { font-weight: 600; font-size: 8.5pt; text-align: right; word-break: break-word; }
  .imei { padding: 1mm 0 0.4mm; border-bottom: 0.6px solid #000; }
  .imei .l { display: block; font-size: 8pt; }
  .iv { font-weight: 700; font-size: 9pt; letter-spacing: 0.3px; word-break: break-all; line-height: 1.15; }
  .r:last-child { border-bottom: none; }
</style></head>
<body><div class="ticket">${rowsHtml}${imeiHtml}${ownerHtml}</div></body></html>`;

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  const done = () => { try { document.body.removeChild(iframe); } catch (e) { /* noop */ } };
  setTimeout(() => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (e) { /* noop */ }
    setTimeout(done, 1500);
  }, 300);
}
